import dayjs from 'dayjs'
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

const Ajv = require('ajv')
const AddFormats = require('ajv-formats')
const ajv = new Ajv()

// ビルトインフォーマット読み込み
AddFormats(ajv)

// キーワード設定
ajv.addKeyword({
  keyword: 'manualDateValidation',
  type: 'string',
  validate: (_schema, data) => {
    /** フォーマットチェック、閏年チェック、存在しない日付チェック */
    const formats = ['YYYY/MM/DD', 'YYYYMMDD']
    let isValidFlg = formats.some((format) => {
      return dayjs(data, format, true).isValid()
    })
    if (!isValidFlg) {
      return false
    }

    /** 1900年より過去チェック */
    const past = dayjs('1900-01-01')
      // eslint-disable-next-line no-magic-numbers
      .set('hour', 0) // eslint-disable-next-line no-magic-numbers
      .set('minute', 0) // eslint-disable-next-line no-magic-numbers
      .set('second', 0)
    if (dayjs(data).isBefore(past)) {
      return false
    }

    /** 未来日チェック 現在日 < 設定日はNG */
    // eslint-disable-next-line no-magic-numbers
    const now = dayjs().set('hour', 0).set('minute', 0).set('second', 0)
    return !dayjs(data).isAfter(now)
  },
  errors: false,
})

// バリデーション設定
const telValidate = ajv.compile({type: 'string', pattern: '^([0-9]{10,11})$'})
const emailValidate = ajv.compile({type: 'string', format: 'email'})
const birthDayFutureCheckValidate = ajv.compile({
  type: 'string',
  manualDateValidation: true,
})
const claimReceiptNumberValidate = ajv.compile({
  type: 'string',
  pattern: '^([0-9]{13})$',
})
const creditCardHolderValidate = ajv.compile({
  type: 'string',
  pattern: '^[A-Z ]*$',
})
const creditCardNumberValidate = ajv.compile({
  type: 'string',
  pattern: '^([0-9]{14,16})$',
})
const creditCardExpireMonthValidate = ajv.compile({
  type: 'string',
  pattern: '^(^(1[0-2])$|^(0[1-9])$)',
})
const creditCardExpireYearValidate = ajv.compile({
  type: 'string',
  pattern: '^([0-9]{2})$',
})
const creditCardSecurityCodeValidate = ajv.compile({
  type: 'string',
  pattern: '^([0-9]{3,4})$',
})

/**
 * 電話番号のバリデーションを行い、結果を返す
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function tel(value) {
  const result = telValidate(value)
  return result
}
/**
 * メールアドレスのバリデーションを行い、結果を返す
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function email(value) {
  const result = emailValidate(value)
  return result
}
/**
 * 誕生日のバリデーションを行い、結果を返す
 * 入力値の妥当性と未来日チェック
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function birthDay(value) {
  const result = birthDayFutureCheckValidate(value)
  return result
}
/**
 * 受付番号のバリデーションを行い、結果を返す
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function claimReceiptNumber(value) {
  const result = claimReceiptNumberValidate(value)
  return result
}
/**
 * カード名義人のバリデーションを行い、結果を返す
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function creditCardHolder(value) {
  return creditCardHolderValidate(value)
}
/**
 * クレジットカード番号のバリデーションを行い、結果を返す
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function creditCardNumber(value) {
  return creditCardNumberValidate(value)
}
/**
 * クレジットカード有効期限(月)のバリデーションを行い、結果を返す
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function creditCardExpireMonth(value) {
  return creditCardExpireMonthValidate(value)
}
/**
 * クレジットカード有効期限(年)のバリデーションを行い、結果を返す
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function creditCardExpireYear(value) {
  return creditCardExpireYearValidate(value)
}
/**
 * クレジットカードセキュリティコードのバリデーションを行い、結果を返す
 * @param {*} value 値
 * @returns バリデーション結果
 */
export function creditCardSecurityCode(value) {
  return creditCardSecurityCodeValidate(value)
}
